export default __webpack_public_path__ + "a1765d1db01a90a11c05893448119b2e.gif";